import { gql } from "@apollo/client";

/**
 * Public, unauthenticated — the signed token in the URL IS the credential.
 *
 * That is safe only because the token is 128 random bits rather than the orderGroup id. The
 * id was the link until 2026-10-04, when it was measured and found derivable: every
 * production ObjectId shares one process-random, so a buyer holding their own link could
 * construct other buyers'. See 4b-cf-api/src/helper/orderToken.js.
 */
export const ORDER_BY_LINK = gql`
  query OrderByLink($token: String!, $sig: String!, $e: String!) {
    orderByLink(token: $token, sig: $sig, e: $e) {
      status
      reason
      shopName
      buyerName
      checklist {
        phone
        address
        carrier
        paid
        paymentRequired
        complete
        missing
      }
      orders {
        code
        createdAt
        totalPrice
        currency
        items {
          name
          qty
          price
        }
      }
    }
  }
`;
